import { User } from "@/generated/graphql"
import { cn } from "@/lib/utils"
import React from "react"

export const Avatar = ({
  viewer,
  size,
}: {
  viewer: Pick<User, "photoUrl" | "firstName" | "lastName">
  size: "md" | "lg"
}) => {
  const { photoUrl, firstName, lastName } = viewer
  return (
    <div
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full overflow-hidden text-white",
        size === "md"
          ? "w-[60px] h-[60px] text-xl"
          : "w-[100px] h-[100px] text-5xl",
        photoUrl ? "bg-neutral-100" : "bg-primary",
      )}
    >
      {photoUrl ? (
        <img src={photoUrl} width="100%" alt={firstName || ""} />
      ) : (
        <div className="flex w-full h-full items-center justify-center font-semibold">
          {firstName?.[0]}
          {lastName?.[0]}
        </div>
      )}
    </div>
  )
}
